import Logger from "../logger";
import { baseContainer } from "../index";
import { toastActions } from "../redux/reducers/toastReducer";
import ActiveDirectoryService from "./activeDirectoryService";
import { Trans } from "react-i18next";
import { renderToString } from "react-dom/server";
import {
  searchGraphUsers,
  searchGraphUserPhoto,
  searchGraphCurrentUserPhoto,
} from "./graphService";

const ALPHANUMERIC_REGEX = "^[\\p{L}0-9'\\-\\s\\.@]+$";

export default class MSGraphService extends ActiveDirectoryService {
  async getUserAvatar(userIdOrPrincipalName = null, isLoggedUser = true) {
    let avatar;
    try {
      const session = baseContainer.getStoreState().session;

      if (!session.avatar || !isLoggedUser) {
        Logger.of("App.msGraphService.getUserAvatar").info();

        let response;
        if (userIdOrPrincipalName) {
          response = await searchGraphUserPhoto(userIdOrPrincipalName);
        } else {
          response = await searchGraphCurrentUserPhoto();
        }

        // If the is no response data return null
        avatar = response.data || null;
      } else {
        avatar = session.avatar;
      }
    } catch {
      avatar = null;
    }
    return avatar;
  }

  async searchUsers(searchTerm) {
    // validate searchTerm before sending graph request
    if (!this.#isSearchTermValid(searchTerm)) {
      baseContainer.store.dispatch(
        toastActions.showErrorMessage(
          renderToString(
            <Trans i18nKey={"components.typeahead.invalidInputErrorMessage"} />
          )
        )
      );
      return [];
    }

    const response = await searchGraphUsers(searchTerm);

    return response.data.map((item) => ({
      ...item,
      value: item.displayName,
    }));
  }

  #isSearchTermValid(searchTerm) {
    try {
      if (new RegExp(ALPHANUMERIC_REGEX, "u").test(searchTerm)) {
        return true;
      }
    } catch {
      return false;
    }
  }
}
